module.exports = __webpack_public_path__ + "img/wrong.2748a6ca.svg";